"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphStyled = void 0;
const react_markdown_1 = __importDefault(require("react-markdown"));
exports.ParagraphStyled = styled(react_markdown_1.default) `
&.octo {
  b,
  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  ul {
    display: flex;
    flex-flow: column wrap;
    gap: 0.25em;
    align-items: stretch;
    justify-content: stretch;
    padding: 0 1em;
    list-style-position: outside;
    list-style-type: disc;
  }

  h3 {
    font-weight: 600;
    font-size: 1.5em;
  }

  h4 {
    font-weight: 600;
    font-size: 1.25em;
  }

  h5 {
    font-weight: 600;
    font-size: 1.15em;
  }

  h6 {
    font-weight: 600;
    font-size: 1.15em;
  }
}
`;
//# sourceMappingURL=Paragraph.styled.js.map